(function (module) {
  'use strict';
  module
    .controller('agencySettingsController', ['$scope', 'progressBar', 'clientSelectService', 'agencySelectService',
      'agencySettings', 'toastFactory', 'ngDialog', 'authService', '$q', '$mdpTimePicker', 'fileReader',
      'providers',
      function ($scope, progressBar, clientSelectService, agencySelectService, agencySettings, toastFactory,
        ngDialog, authService, $q, $mdpTimePicker, fileReader, providers) {
        const progress = progressBar.getProgressBar();
        let readyToUpload = false;
        let selectedFilename = null;
        $scope.isUpdate = false;
        $scope.agencySettings = {};
        $scope.startBusinessHours = {};
        $scope.endBusinessHours = {};
        // List of Days
        $scope.dayList = [{
          id: 1,
          name: 'Sunday',
        }, {
          id: 2,
          name: 'Monday',
        }, {
          id: 3,
          name: 'Tuesday',
        }, {
          id: 4,
          name: 'Wednesday',
        }, {
          id: 5,
          name: 'Thursday',
        }, {
          id: 6,
          name: 'Friday',
        }, {
          id: 7,
          name: 'Saturday',
        },];
        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
          };
        }
        // Get Agency by ID
        function getAgencyById() {
          $scope.agencySettings.LogoImageLink = null;
          $scope.agencySettings = {};
          $scope.startBusinessHours = {};
          $scope.endBusinessHours = {};
          $scope.defaultOrgDayFrom = 0;
          $scope.defaultOrgDayTo = 0;
          $scope.selTimeZoneId = 0;
          $scope.isUpdate = false;
          if (authService.getLoginMember().Role === 4) {
            const valid = validateAgencyAndClientSelection();
            if (valid.agencyValid) {
              let organization = agencySelectService.getSelectedAgency();
              getAgencyDetails(organization.id);
            } else {
              if (valid.agencyValid === false) {
                //toastFactory.toast_info('Please select an agency.');
              }
            }
          } else {
            getAgencyDetails(authService.getLoginMember().OrganizationId);
          }
        };

        function getAgencyDetails(organizationId) {
          progress.start();
          $scope.agencySettings.LogoImageLink = null; 
			    $scope.startBusinessHours = new Date(0, 0, 0, 0, 0);
		      $scope.endBusinessHours = new Date(0, 0, 0, 0, 0);		  
          const promiseTimeZone = agencySettings.getWindowsTimeZones();
          const promiseAgencySettings = agencySettings.getAgencyById(organizationId);
          $q.all([promiseTimeZone, promiseAgencySettings]).then(function (response) {            
              $scope.timeZones = response[0].data;
              $scope.selTimeZoneId = 0;
              $scope.agencySettings = response[1].data;
              $scope.defaultOrgDayFrom = response[1].data.DefaultServiceStartDay;
              $scope.defaultOrgDayTo = response[1].data.DefaultServiceEndDay;
              $scope.selTimeZoneId = ((!!response[1].data.DefaultWindowsTimeZone) ? response[1].data.DefaultWindowsTimeZone
                .Id : '');   
			
              if($scope.agencySettings.DefaultStartRegularHours === null && $scope.agencySettings.DefaultEndRegularHours === null) {
                $scope.startBusinessHours = new Date(0, 0, 0, 0, 0);
                $scope.endBusinessHours = new Date(0, 0, 0, 0, 0); 
              } else {
                const startHourDate = ((!!$scope.agencySettings.DefaultStartRegularHours) ? $scope.agencySettings.DefaultStartRegularHours
                  .split(':') : '');
                const endHourDate = ((!!$scope.agencySettings.DefaultEndRegularHours) ? $scope.agencySettings.DefaultEndRegularHours
                  .split(':') : '');
                const startHour = startHourDate[0];              
                const startMin = startHourDate[1];   
                const endHour = endHourDate[0];
                const endMin = endHourDate[1];
                $scope.startBusinessHours = new Date(0, 0, 0, startHour, startMin);
                $scope.endBusinessHours = new Date(0, 0, 0, endHour, endMin);
				      }
              const agency = $scope.agencySettings;
              if (!!agency.DefaultStartRegularHours || !!agency.DefaultEndRegularHours || !!agency.DefaultServiceStartDay ||
                !!agency.DefaultServiceEndDay || !!agency.DefaultWindowsTimeZoneId || !!agency.DefaultPhone ||
                !!
                agency.DefaultAfterHoursPhone || !!agency.DefaultEmail || !!agency.WebSite || !!agency.LogoImageLink
              ) {
                $scope.isUpdate = true;
              }
            }, function (err) {

              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText}</p>`;
                  $scope.errTitle = 'Agency Settings Error';
                },],
              });
            })
            .finally(function () {
              progress.complete();
            });
        }
        // code for upload image
        $scope.getFile = function () {
          fileReader.readAsDataUrl($scope.file, $scope)
            .then(function (result) {
              $scope.agencySettings.LogoImageLink = result;
            });
        };

        $scope.setFile = function (event) {
          selectedFilename = event.target.files[0];
          readyToUpload = true;
          fileReader.readAsDataUrl(selectedFilename, $scope)
            .then(function (result) {
              $scope.agencySettings.LogoImageLink = result;
            });

          $scope.$apply();
        };

        $scope.clearFile = function () {
          readyToUpload = false;
          selectedFilename = null;
          $scope.agencySettings.LogoImageLink = '//:0';
        };

        function uploadImage(img) {
          if (img != null) {
            return providers.uploadImage(img).then(function (result) {
              const cloudinaryObj = result.data;
              const public_filename = cloudinaryObj.public_id + '.' + cloudinaryObj.format; // e.g. 'filename.jpg'
              return providers.transformImage(public_filename).then(function (result) {
                return result.data;
              });
            });
          }
        };
        // Update agency
        $scope.updateAgency = function () {
          const startHour = $scope.startBusinessHours.getHours();
          const startMin = $scope.startBusinessHours.getMinutes();
          const endHour = $scope.endBusinessHours.getHours();
          const endMin = $scope.endBusinessHours.getMinutes();
          $scope.agencySettings.DefaultStartRegularHours = startHour + ':' + startMin;
          $scope.agencySettings.DefaultEndRegularHours = endHour + ':' + endMin;
          let agencySetting = $scope.agencySettings;
          agencySetting.DefaultServiceStartDay = $scope.defaultOrgDayFrom;
          agencySetting.DefaultServiceEndDay = $scope.defaultOrgDayTo;          
          agencySetting.DefaultWindowsTimeZoneId = (!!$scope.selTimeZoneId ? $scope.selTimeZoneId : 0);
          if (readyToUpload) {
            // pipe raw to cloudinary, retrieve transformed cloudinary url and replace LogoImageLink
            uploadImage(selectedFilename).then(function (result) {
              if (result != null) {
                $scope.agencySettings.LogoImageLink = result;
                UpdateDefaultAgency($scope.agencySettings);
              }
            });
          } else {
            $scope.agencySettings.LogoImageLink = null;
            UpdateDefaultAgency($scope.agencySettings);
          }
        };

        function UpdateDefaultAgency(agencyDefault) {
          progress.start();
          agencySettings.updateAgency(agencyDefault.Id, agencyDefault).then(function (agencyDefault) {
            if (!!$scope.isUpdate) {
              ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.strTitle = 'Update Agency Setting Successfully';
                  $scope.successMsg = 'Agency has been updated succesfully.';
                },],
              });
            } else {
              ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.strTitle = 'Save Agency Setting Successfully';
                  $scope.successMsg = 'Agency has been Saved succesfully.';
                },],
              });

            }
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText}</p>`;
                $scope.errTitle = 'Update Agency Error';
              },],
            });
          })
            .finally(function () {
              progress.complete();
            });
        };

        getAgencyById();
        // Watch orgFilterService for changes to getFilteredOrganization() output
        // expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function () {
          return agencySelectService.getSelectedAgency();
        }, function (newValue, oldValue) {

          if (newValue !== oldValue) {
            $scope.agencySettings.LogoImageLink = null;
            getAgencyById();
          } else {
            $scope.agencySettings.LogoImageLink = null;
            $scope.agencySettings = {};
          }
        }, true);
      },
    ]);
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/controllers/agencySettingsController.js